export default {
  slidersData: (state) => state.sliders || [],
  popupSlideData: (state) => state.popupSlide || {},
};
